/* Trio TCG — slider bars under the homepage card rows (Popular, Just listed, Magic). */
(function () {
  'use strict';
  if (!document.body.classList.contains('tpl-index')) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var arrow = function (d) { return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="' + (d < 0 ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>'; };

  function initRailBars(scope) {
    $$('section.rowsec', scope).forEach(function (sec) {
      if (sec.getAttribute('data-bar') || sec.hasAttribute('data-reviews') || !sec.querySelector('[data-rail]')) return;
      sec.setAttribute('data-bar', '1');

      var holder = document.createElement('div');
      holder.className = 'wrap rbar-wrap';
      holder.innerHTML =
        '<div class="rbar">' +
          '<button type="button" class="rbar-btn" data-dir="-1" aria-label="Scroll cards left">' + arrow(-1) + '</button>' +
          '<div class="rbar-track" role="slider" tabindex="0" aria-label="Scroll the cards" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span class="rbar-thumb"></span></div>' +
          '<button type="button" class="rbar-btn" data-dir="1" aria-label="Scroll cards right">' + arrow(1) + '</button>' +
        '</div>';
      sec.appendChild(holder);

      var bar = holder.firstChild, track = holder.querySelector('.rbar-track'), thumb = holder.querySelector('.rbar-thumb');
      var prev = holder.querySelector('[data-dir="-1"]'), next = holder.querySelector('[data-dir="1"]');
      var drag = null, queued = false;

      // the row on show right now (Popular has one row per chip, only one visible)
      function rail() { return $$('[data-rail]', sec).filter(function (r) { return !r.hidden; })[0]; }
      function maxScroll(r) { return Math.max(0, r.scrollWidth - r.clientWidth); }

      function update() {
        queued = false;
        var r = rail();
        var max = r ? maxScroll(r) : 0;
        holder.hidden = max <= 4;                      // nothing to scroll, no bar
        if (holder.hidden) return;
        var tw = track.clientWidth;
        var w = Math.max(48, tw * r.clientWidth / r.scrollWidth);
        var p = Math.min(1, Math.max(0, r.scrollLeft / max));
        thumb.style.width = w + 'px';
        thumb.style.transform = 'translateX(' + ((tw - w) * p) + 'px)';
        prev.disabled = r.scrollLeft <= 2;
        next.disabled = r.scrollLeft >= max - 2;
        track.setAttribute('aria-valuenow', Math.round(p * 100));
      }
      function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }

      function step(r) { var c = r.querySelector('.rtrack > *'); return c ? c.getBoundingClientRect().width + 20 : 280; }
      function go(dir, page) {
        var r = rail(); if (!r) return;
        var by = page ? Math.max(step(r), r.clientWidth * 0.8) : step(r);
        r.scrollBy({ left: dir * by, behavior: reduce ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1, true); });
      next.addEventListener('click', function () { go(1, true); });

      // drag the thumb, or tap anywhere on the bar to jump there
      function moveTo(e) {
        if (!drag) return;
        var r = drag.r, tr = track.getBoundingClientRect(), room = tr.width - thumb.offsetWidth;
        if (room <= 0) return;
        var x = Math.max(0, Math.min(room, e.clientX - tr.left - drag.grab));
        r.scrollLeft = x / room * maxScroll(r);
      }
      track.addEventListener('pointerdown', function (e) {
        var r = rail(); if (!r || (e.pointerType === 'mouse' && e.button !== 0)) return;
        e.preventDefault();
        var th = thumb.getBoundingClientRect();
        drag = { r: r, grab: e.target === thumb ? e.clientX - th.left : th.width / 2 };
        r.style.scrollSnapType = 'none';               // let the row follow the finger exactly
        bar.classList.add('dragging');
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
        moveTo(e);
      });
      track.addEventListener('pointermove', moveTo);
      function end() {
        if (!drag) return;
        var r = drag.r; drag = null;
        bar.classList.remove('dragging');
        r.style.scrollSnapType = '';                   // settle onto the nearest card
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('lostpointercapture', end);

      track.addEventListener('keydown', function (e) {
        var r = rail(); if (!r) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        else if (e.key === 'PageDown') { e.preventDefault(); go(1, true); }
        else if (e.key === 'PageUp') { e.preventDefault(); go(-1, true); }
        else if (e.key === 'Home') { e.preventDefault(); r.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); }
        else if (e.key === 'End') { e.preventDefault(); r.scrollTo({ left: maxScroll(r), behavior: reduce ? 'auto' : 'smooth' }); }
      });

      $$('[data-rail]', sec).forEach(function (r) {
        r.addEventListener('scroll', queue, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(queue).observe(r);
      });
      // Popular: a chip swaps which row is showing
      $$('.pop-chip', sec).forEach(function (c) { c.addEventListener('click', function () { requestAnimationFrame(queue); }); });
      addEventListener('resize', queue);
      addEventListener('load', queue);
      update();
    });
  }

  initRailBars(document);
  document.addEventListener('shopify:section:load', function (e) { initRailBars(e.target); });
})();
